import React from 'react'
import PropTypes from 'prop-types'

const ItemList = ({items, renderItem}) => {
    return (
        <>
            {Array.isArray(items) &&
                items.length > 0 &&
                items.map((item, index) => renderItem(item, index))}
        </>
    )
}

export default ItemList

ItemList.propTypes = {
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,
}
